import { createContext, createElement, useContext, useMemo } from 'react';
import { assertPlatformWebHost, PlatformWebHostMissingError } from './host.js';
const PlatformWebHostContext = createContext(undefined);
PlatformWebHostContext.displayName = 'PlatformWebHost';
/** Refuses (throws while rendering) a host missing any roster capability. */
export function PlatformWebHostProvider({ host, children }) {
    const checked = useMemo(() => {
        assertPlatformWebHost(host);
        return host;
    }, [host]);
    return createElement(PlatformWebHostContext.Provider, { value: checked }, children);
}
/** Throws PlatformWebHostMissingError outside a provider — never an undefined host. */
export function usePlatformWebHost() {
    const host = useContext(PlatformWebHostContext);
    if (host === undefined)
        throw new PlatformWebHostMissingError();
    return host;
}
//# sourceMappingURL=context.js.map